import LoaderBalls from 'components/LoaderBalls'
import React, { Suspense } from 'react'

export const LazyCard = (LazyComponent, Fallback = LoaderBalls) => {
  return (props) => {
    return (
      <Suspense fallback={<Fallback />}>
        <LazyComponent {...props}/>
      </Suspense>
    )
  }
}
